import React from 'react';
import { Page } from '../Page';
import { Brain, Clock, Moon } from 'lucide-react';
export function SupplementSleepSupport() {
  return <Page pageNumber={30} variant="light" data-id="element-3651" data-mp="25tffj1wtaumr">
      <div className="flex flex-col h-full" data-id="element-3652" data-mp="20tjbx3s1157q">
        <div className="mb-6 pt-4" data-id="element-3653" data-mp="20shy4rjmm4mb">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3654" data-mp="20vnrwk379uod">
            Supplement Spotlight
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3655" data-mp="1rtejbzrhsbdm">
            Sleep Support
          </h1>
          <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3656" data-mp="1n0tpiy8l5ya3">
            Two approaches based on your needs
          </p>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-3657" data-mp="1i0yx2q95x0mx" />
        </div>

        <div className="mb-8" data-id="element-3658" data-mp="1d5tdvz75a02j">
          <h2 className="text-sm font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3659" data-mp="1d2dxmt1qikzj">
            Why It Matters on GLP-1
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-3660" data-mp="143ag3ti7udn5">
            Sleep quality is a major lever for GLP-1 success. Poor sleep
            elevates cortisol, increases hunger hormones, and stalls weight
            loss. GLP-1 medications can also disrupt sleep patterns during dose
            adjustments. Choose the approach that best matches your sleep
            challenges.
          </p>
        </div>

        {/* 2 Bottles Row */}
        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-3661" data-mp="3jtnbhe9ydg8a">
          <div className="flex flex-col items-center" data-id="element-3662" data-mp="bgzk2eo936my">
            <img src="https://cdn.magicpatterns.com/uploads/uV7kMwb5546qEb7k2tWpLB/pasted-image.png" alt="Deep Sleep Complex" className="h-48 object-contain mb-4" data-id="element-3663" data-mp="gf10eruakruq" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3664" data-mp="7dtezacvjli2">
              Deep Sleep Complex
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3665" data-mp="2n4nzppa5twbc">
              Stress-Driven Insomnia
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-3666" data-mp="xo28nrhxk5u2">
            <img src="https://cdn.magicpatterns.com/uploads/rTKAMShBVdKX1odvM4WFhY/pasted-image.png" alt="Melaton-3" className="h-48 object-contain mb-4" data-id="element-3667" data-mp="xntqpl6yaac0" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3668" data-mp="nwfo34jpcuen">
              Melatonin (3mg or 5mg)
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3669" data-mp="exkjfwwb3sdg">
              Circadian Rhythm Reset
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-3670" data-mp="4z4otjy2m0z7">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 flex flex-col" data-id="element-3671" data-mp="4zxx4pcogyjg">
            <Brain className="w-5 h-5 text-tealslate mb-3" data-id="element-3672" data-mp="znikoatkzsz" />
            <h4 className="text-xs font-bold text-[#1F1F1F] mb-2" data-id="element-3673" data-mp="1ze79n4c6cuvs">
              Best for a Busy Mind
            </h4>
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3674" data-mp="1vd5byrxwoqvx">
              Melatonin-free, non-habit-forming. Uses Maizinol®, L-theanine,
              and chamomile to modulate cortisol and promote relaxation.
              <br data-id="element-3675" data-mp="3i6z3y5ierq38" />
              <br data-id="element-3676" data-mp="3i6gz4khok3jp" />
              <strong data-id="element-3677" data-mp="3mzs9gvlpb2gd">Timeline:</strong> 20min stress balance → 60min relaxation
              → 1 week faster sleep onset.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3678" data-mp="3qzu089pwebgv">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3679" data-mp="2ube5lz7xlbww">
                2 caps before bed
              </p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3680" data-mp="2zaz6if6nvuc9">60 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 flex flex-col" data-id="element-3681" data-mp="33arg8v7sk6j7">
            <Clock className="w-5 h-5 text-tealslate mb-3" data-id="element-3682" data-mp="38boyt8wpr2l8" />
            <h4 className="text-xs font-bold text-[#1F1F1F] mb-2" data-id="element-3683" data-mp="ilbw2j32vg2j">
              Best for Jet Lag & Shift Work
            </h4>
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3684" data-mp="njlrmuspsioo">
              Direct melatonin supplementation. Promotes the resynchronization
              of your circadian cycle and enhances GABA for relaxation. Also
              provides antioxidant and GI health benefits.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3685" data-mp="v4z3d1jh18bw">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3686" data-mp="r2kk4gbw46k3">
                1 cap at bedtime
              </p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3687" data-mp="151bxu1mubq7p">
                60 caps per bottle (available in 3mg or 5mg)
              </p>
            </div>
          </div>
        </div>

        <div className="mt-auto flex items-center gap-3" data-id="element-3688" data-mp="1erncai45hhsu">
          <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3689" data-mp="1er3rmtn48fb4" />
          <div data-id="element-3690" data-mp="1nq8uud9mgwtm">
            <p className="text-xs font-bold text-[#1F1F1F]" data-id="element-3691" data-mp="1its55emryaef">
              Choose Your Approach
            </p>
            <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3692" data-mp="22es91bojy5vn">
              If you're interested in a supplement plan tailored to you, check
              out the link below! Fullscript provides third-party tested, safe
              and effective supplements to help get your health where you want
              it at wholesale prices.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}